export default {"src":"/_next/static/media/dollar.1abdaaa2.svg","height":32,"width":23};